import { render, staticRenderFns } from "./Spots.vue?vue&type=template&id=8ce9bfc8"
import script from "./Spots.vue?vue&type=script&lang=js"
export * from "./Spots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports